import { CustomTableSortState } from '@components/custom-table/types';

const TRANSACTION_SORT_KEYS = {
  NAME: 'member_name',
  ADMISSION_NUMBER: 'admission_number',
  REQUESTED_ON: 'requested_on',
  PAID_ON: 'paid_at',
  AMOUNT: 'total_amount',
  SETTLED_ON: 'settled_on'
} as const;

export const PAID_TRANSACTIONS_DEFAULT_SORT: CustomTableSortState = {
  sortBy: TRANSACTION_SORT_KEYS.PAID_ON,
  sortOrder: 'desc'
};

export default TRANSACTION_SORT_KEYS;
